<div class="custom-domains-container settings-page">

  <div class="settings-page__content">
    <p class="settings-page__description">
      {{ 'SETTINGS_CUSTOM_DOMAINS.SUBTITLE' | translate }}
    </p>
    <tf-settings-custom-domains-list />
  </div>
</div>
